import { opensWithFacts } from '../../openingAnimation';

/**
 * The catalog's description of a card — year, set, player, grade and the rest
 * — as the backend's enrichment wrote it. Its shape follows the card's
 * category (a sport card and a Pokémon card describe different things), so
 * it crosses the wire untyped and is read field by field (see `cardFacts`).
 * Absent unless the request asked for it, and null until a card is enriched.
 */
export type CardDetails = Record<string, unknown>;

export function asCardDetails(raw: unknown): CardDetails | null {
  return raw !== null && typeof raw === 'object' && !Array.isArray(raw)
    ? (raw as CardDetails)
    : null;
}

/**
 * `?include_card_details=true`, but only when the pack being opened plays a
 * mechanic that tells the card's facts before it flips (the carousel today).
 * The backend builds that section per item, and the slot lane, slice and
 * burst would never say a word of it.
 *
 * The mechanic is read from the opening-animation store: the global one
 * arrives with design_system at boot, a pack's own override with its payload.
 * `offerId` names the pack when the caller knows it; without it (or for a pack
 * not seen yet) any mechanic of this session that tells facts asks for them.
 * `tellsFacts`, when given, is the mechanic the caller is actually playing and wins.
 */
export function cardDetailsQuery(offerId?: string | number | null, tellsFacts?: boolean): string {
  return (tellsFacts ?? opensWithFacts(offerId)) ? '?include_card_details=true' : '';
}
